import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { TokenStorageService } from './token-storage.service';
const API_URL = environment.apiUrl + 'printarticle';
@Injectable({
    providedIn: 'root'
})
export class PrintarticleService {
    authtoken: string;
    private httpOptions;
    constructor(private http: HttpClient, private token: TokenStorageService) {
        this.authtoken = this.token.getToken();
        this.httpOptions = {
            headers: new HttpHeaders()
                .set("Content-Type", "application/json")
                .set('Authorization', `Bearer ${this.authtoken}`)
        };
    }
    getPrintarticleList(query): Observable<any> {
        return this.http.get(API_URL + query);
    }
    getPrintarticleDetails(id): Observable<any> {
        return this.http.get(API_URL + '/' + id);
    }
    updatePrintarticle(id, userdata): Observable<any> {
        return this.http.put(API_URL + '/' + id, userdata);
    }
    addPrintarticle(printarticledata): Observable<any> {
        return this.http.post(API_URL, printarticledata);
    }
    uploadPrintarticleCsv(csvData): Observable<any> {
        return this.http.post(API_URL + '/uploadCSV', csvData);
    }
    uploadPrintarticleImages(imagesData): Observable<any> {
        return this.http.post(API_URL + '/uploadImages', imagesData);
    }
}